/**
 * The contact form's native POST/redirect only echoes back email + body on a
 * failed submit — every other field resets to blank. Snapshots the form to
 * sessionStorage on submit and restores it next load, until a submit succeeds.
 */

const FORM_SELECTOR = ".contact--form";
const STORAGE_KEY = "quickfireContactFormDraft";

function readDraft() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");
  } catch {
    return null;
  }
}

function restore(form) {
  const draft = readDraft();
  if (!draft) return;

  Object.entries(draft).forEach(([name, value]) => {
    const field = form.elements.namedItem(name);
    if (!field) return;

    if (field instanceof RadioNodeList) {
      Array.from(field).forEach((el) => {
        if (el.type === "checkbox" || el.type === "radio") {
          el.checked = el.value === value;
        }
      });
      return;
    }

    if (field.type === "checkbox") {
      field.checked = true;
    } else {
      field.value = value;
    }
  });
}

function bindSubmit(form) {
  form.addEventListener("submit", () => {
    const data = {};
    new FormData(form).forEach((value, key) => {
      if (typeof value === "string") data[key] = value;
    });
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch {}
  });
}

export function init(root = document) {
  const form = root.querySelector(FORM_SELECTOR);
  if (!form || form.dataset.persistBound === "true") return;
  form.dataset.persistBound = "true";

  const postedSuccessfully = Boolean(form.querySelector(".form-status.form-success"));
  if (postedSuccessfully) {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {}
  } else {
    restore(form);
  }

  bindSubmit(form);
}

init();

document.addEventListener("shopify:section:load", (event) => {
  init(event?.target || document);
});
